import TooltipMUI from "@mui/material/Tooltip";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import React, { useState } from "react";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    tooltipWhiteArrow: {
      display: "none",
    },
    tooltipWhite: ({ maxWidth }: { maxWidth?: string }) => ({
      backgroundColor: theme.white50,
      boxShadow: "2px 4px 16px rgba(0, 0, 0, 0.2)",
      borderRadius: "8px",
      color: theme.gray500,
      padding: theme.spacing(9, 8),
      maxWidth: maxWidth || undefined,
      whiteSpace: "break-spaces",
    }),
  }),
);

type Props = {
  className?: string;
  placement?:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
  text: string | number | React.ReactElement | React.ReactNode;
  children: React.ReactElement;
  "data-test-id"?: string;
  isOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  customHandler?: boolean;
  disableHoverListener?: boolean;
  leaveDelay?: number;
  maxWidth?: string;
};

export function Tooltip({
  className = "",
  placement = "bottom",
  text,
  children,
  isOpen,
  onOpen,
  onClose,
  "data-test-id": dataTestId,
  customHandler = false,
  disableHoverListener = false,
  leaveDelay,
  maxWidth,
}: Props) {
  const [isVisible, setVisibility] = useState(false);
  const classes = useStyles({ maxWidth });

  return (
    <TooltipMUI
      disableHoverListener={disableHoverListener}
      onOpen={customHandler ? onOpen : () => setVisibility(true)}
      onClose={customHandler ? onClose : () => setVisibility(false)}
      open={customHandler ? isOpen : isVisible}
      leaveDelay={leaveDelay}
      arrow
      className={className}
      title={text}
      sx={[
        (theme) => ({
          height: theme.spacing(7),
          marginLeft: theme.spacing(2),
          opacity: ".3",
          verticalAlign: "middle",
          width: theme.spacing(7),
        }),
      ]}
      placement={placement}
      classes={{
        tooltip: classes.tooltipWhite,
        arrow: classes.tooltipWhiteArrow,
      }}
      data-test-id={dataTestId && dataTestId}
    >
      {children}
    </TooltipMUI>
  );
}
